import { lazy, Suspense, useState } from 'react';
import { IoShareSocialOutline } from 'react-icons/io5';

// Loaded when the dialog is opened, so the panels that show this button do
// not pull in the whole API module.
const ShareChatModal = lazy(() => import('../chat/ShareChatModal'));

// "Share" on a dashboard item: gives one project member access to this
// commitment, risk, dependency or deliverable.
const ShareButton = ({ itemType, itemId, title }) => {
  const [open, setOpen] = useState(false);
  if (!itemId) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Let another project member read this item"
        className="inline-flex items-center gap-1 rounded-md border border-zinc-600 px-2 py-1 text-[12px] text-zinc-300 hover:bg-zinc-800"
      >
        <IoShareSocialOutline /> Share
      </button>
      {open && (
        <Suspense fallback={null}>
          <ShareChatModal
            item={{ type: itemType, id: itemId, title }}
            accessToken={localStorage.getItem('projectToken')}
            onClose={() => setOpen(false)}
          />
        </Suspense>
      )}
    </>
  );
};

export default ShareButton;
